import { render, staticRenderFns } from "./DownloadDetails.vue?vue&type=template&id=2bb85c28&scoped=true"
import script from "./DownloadDetails.vue?vue&type=script&lang=js"
export * from "./DownloadDetails.vue?vue&type=script&lang=js"
import style0 from "./DownloadDetails.vue?vue&type=style&index=0&id=2bb85c28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb85c28",
  null
  
)

export default component.exports